import 'virtual:tokens.css';
import './styles/fonts';
import './styles/base.css';
import { initLang } from './i18n';
import { initTheme } from './lib/theme';

initTheme();
initLang();
